import { useState, useEffect, useRef } from "react";
import { useNotification } from "./useNotification";
import { localDevCatch } from "../utils";
import { isDev } from "../../config";
import { checkJobStatus } from "../../services/TFG/JobsService";
import { mockedJobStatusFinished } from "../../services/TFG/JobsService.mock";

const MAX_ATTEMPTS_ERROR = "Max attempts";

export const useJob = (
  interval = 1000,
  maxAttempts = isDev ? 5 : 100
) => {
  const [progress, setProgress] = useState(0);
  const [status, setStatus] = useState("PENDING");
  const intervalRef = useRef(null);
  const attemptRef = useRef(0);
  const notification = useNotification();

  const startChecking = (jobId) => {
    if (intervalRef.current) return;

    notification("info", "Iniciando descarga en segundo plano.");
    setStatus("RUNNING");

    intervalRef.current = setInterval(async () => {
      try {
        const data = await checkJobStatus(jobId).then((data) => {
          if (attemptRef.current >= maxAttempts) {
            return localDevCatch(MAX_ATTEMPTS_ERROR, mockedJobStatusFinished);
          }
          return data;
        });

        setProgress(data.progress);
        setStatus(data.status);

        if (data.status === "FINISHED") {
          notification(
            "success",
            "Se ha completado el procesamiento del fichero."
          );
          stopChecking();
        }
        if (data.status === "FAILED") {
          notification("error", "Error durante el procesamiento del fichero.");
          stopChecking();
        }

        attemptRef.current += 1;
      } catch (error) {
        const errorMessage =
          error === MAX_ATTEMPTS_ERROR
            ? "Tiempo de espera excedido."
            : "Error al comprobar el estado del procesamiento.";
        notification("error", errorMessage);
        stopChecking();
      }
    }, interval);
  };

  const stopChecking = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    attemptRef.current = 0;
  };

  /* const mockSuccessfulJob = () => {
    const data = await 
  } */

  useEffect(() => {
    return () => stopChecking(); // Cleanup on unmount
  }, []);

  return { progress, status, startChecking, stopChecking };
};
